import React from 'react';
import {SecSubTitle, SecTitle, ServiceBoxOne, TitleWrap} from '../../components';
import ServiceBoxOneEInvoice from "../../components/ServiceBox/ServiceBoxOneEInvoice";

const ServiceOneEInvoice = ({data,className})=>  (
  <div  className="background-image space-top" style={{backgroundImage: 'url(images/bg/about-bg-5-1.jpg)'}}>
    <div className="container">
      <div className="row justify-content-center text-center">
        <div className="col-lg-8 col-xl-6">
          <TitleWrap>
            <SecTitle className="h1">Key Features</SecTitle>
          </TitleWrap>
        </div>
      </div>
      <div className="row justify-content-center">
        {data.map(item => (
          <div className="col-md-6 col-lg-4" key={item.id}>
            <ServiceBoxOneEInvoice
              bgImage={item.bgShape}
              title={item.title}
              text={item.text}
            />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ServiceOneEInvoice;